<template>
  <v-container
    class="video-section-wrapper"
    :style="{
      'background-color': data.color,
    }"
    fluid
  >
    <v-row>
      <v-col
        class="col-12 col-md-10 pa-md-0 offset-md-1 col-lg-12 offset-lg-0 text-wrapper"
      >
        <h2 v-html="data.title"></h2>
        <h5 v-if="data.subtitle">{{ data.subtitle }}</h5>
        <p v-if="data.text" v-html="data.text"></p>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col-12 pa-md-0">
        <div class="video-preview">
          <a
            data-fancybox="video"
            :href="`https://www.youtube.com/watch?v=${data.videoId}&amp;rel=0&amp;autoplay=1`"
          >
            <img :src="data.thumb" :alt="data.title" />
          </a>
        </div>
      </v-col>
    </v-row>
    <v-row v-if="data.button">
      <v-col class="col-12 pa-md-0 d-flex justify-center align-center">
        <a
          v-if="
            data.button.smooth_scroll === true ||
            data.button.smooth_scroll_custom === true
          "
          :href="data.button.url"
          :target="data.button.external_url === true ? '_blank' : '_self'"
          :style="{ background: data.button.color ? data.button.color : '' }"
          class="button"
          @click="scrollToForm"
          >{{ data.button.text }}</a
        >
        <a
          v-else
          :href="data.button.url"
          :target="data.button.external_url === true ? '_blank' : '_self'"
          :style="{ background: data.button.color ? data.button.color : '' }"
          class="button"
          >{{ data.button.text }}</a
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

export default {
  name: 'VideoSectionBusinesses',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  beforeMount() {},
  mounted() {
    // Fancybox init
    Fancybox.bind('[data-fancybox]', {});
  },
  methods: {
    scrollToForm() {
      if (this.data.button.smooth_scroll_custom) {
        this.$vuetify.goTo(
          document.querySelector(`.${this.data.button.scroll_to_section}`)
            .offsetTop - document.getElementById('navbar').offsetHeight,
        );
      } else {
        this.$vuetify.goTo(
          document.querySelector('.form-section-wrapper').offsetTop -
            document.getElementById('navbar').offsetHeight,
        );
      }
    },
  },
};
</script>

<style lang="sass" scoped>
@import '@/styles/util'
@import '@/styles/style'

.video-section-wrapper
  padding: 100px 12px
  .text-wrapper
    justify-content: center
    align-items: center
    display: flex
    flex-flow: column
    h2,
    h5,
    p
      font-style: normal
      line-height: 1
      color: #003036
    h2
      display: inline-block
      font-family: 'metropolissemi_bold'
      font-weight: 600
      font-size: 32px
      padding-bottom: 5px
      border-bottom: 4px solid #26D07C
      margin-bottom: 10px
      ::v-deep
        span
          font-family: 'metropolisregular'
          font-weight: 400
    h5
      display: inline-block
      font-family: 'metropolisbold'
      font-weight: 700
      font-size: 18px
      margin-bottom: 50px
    p
      max-width: 1200px
      display: inline-block
      font-family: 'metropolisregular'
      font-weight: 400
      font-size: 18px
      line-height: 1.3
      margin-top: 20px
      margin-bottom: 50px
      ::v-deep
        span
          font-family: 'metropolisbold'
          font-style: normal
          font-weight: 700
  .button
    background: #003036
    display: inline-block
    font-family: 'metropolisbold'
    font-weight: 700
    line-height: 1
    font-size: 16px
    color: #ffffff
    text-transform: uppercase
    text-align: center
    outline: none
    text-decoration: none
    padding: 12px 48px
    margin-top: 50px
    border-radius: 20px
    transition: all 300ms ease-in-out
    &:hover
      background: #3DCF8E
      transition: all 300ms ease-in-out
  .video-preview
    position: relative
    display: block
    max-width: 1200px
    margin: 0 auto
    a
      position: relative
      display: block
      width: 100%
      height: 100%
      text-align: center
      text-decoration: none
      outline: none
      cursor: pointer
      &:after
        background: url("~@/assets/images/businesses-pages/icon-play.png") center center no-repeat
        content: ""
        position: absolute
        display: block
        width: 67px
        height: 67px
        top: 50%
        left: 50%
        transform: translate(-50%, -50%)
      img
        display: block
        width: 100%
  @media screen and (max-width: 959px)
    padding: 40px 12px
    .text-wrapper
      h5
        font-size: 16px
</style>
